import { FunctionsHttpError } from "@supabase/supabase-js";
import { supabase } from "./supabase";

/** Fehler einer Edge Function mit maschinenlesbarem Code (für i18n: errors.<code>). */
export class ApiError extends Error {
  constructor(
    readonly code: string,
    message: string,
    readonly requestId?: string,
  ) {
    super(message);
  }
}

/**
 * Edge Function aufrufen. supabase-js wirft hier nicht — die Antwort wird ausgewertet:
 * Fehler werden zu ApiError, eine leere Antwort ist ein Fehler, kein „nichts passiert".
 */
export async function callFunction<T>(name: string, body: Record<string, unknown>): Promise<T> {
  const { data, error } = await supabase.functions.invoke(name, { body });
  if (error) {
    if (error instanceof FunctionsHttpError) {
      const payload = await error.context.json().catch(() => ({}));
      throw new ApiError(payload.error ?? "request_failed", payload.message ?? error.message, payload.requestId);
    }
    throw new ApiError("network_error", error.message);
  }
  if (data === null || data === undefined) throw new ApiError("empty_response", `${name}: leere Antwort`);
  return data as T;
}

/** Rückgabe einer PostgREST-Abfrage entscheiden: Fehler ⇒ werfen, sonst Daten (nie stillschweigend leer). */
export function unwrap<T>(result: { data: T | null; error: { message: string; code?: string } | null }): T {
  if (result.error) throw new ApiError(result.error.code ?? "db_error", result.error.message);
  if (result.data === null) throw new ApiError("not_found", "Keine Daten");
  return result.data;
}
